const teamFilterInput = document.getElementById("team-filter-input");

if (!teamFilterInput) return;

teamFilterInput.addEventListener("keyup", () => {
  setTimeout(() => {
    const filterValue = teamFilterInput.value.toLowerCase();

    // Select all group divs
    const letterGroups = document.querySelectorAll("[data-letter-group]");

    if (!letterGroups) return;

    letterGroups.forEach((group) => {
      const groupLetter = group.getAttribute("data-letter-group").toLowerCase();

      // Check if the first letter of the group matches the first letter of the input
      if (filterValue.charAt(0) === groupLetter || filterValue === "") {
        group.classList.remove("hidden"); // Show the group
      } else {
        group.classList.add("hidden"); // Hide the group
      }
    });

    // Select all team elements
    const teams = document.querySelectorAll("[data-team-name]");

    if (!teams) return;

    teams.forEach((team) => {
      // Get the team's name and convert it to lowercase
      const teamName = team.dataset.teamName.toLowerCase();

      // Check if the team's name includes the filter value,
      if (teamName.includes(filterValue)) {
        team.classList.remove("hidden"); // Show team element
      } else {
        team.classList.add("hidden"); // Hide team element
      }
    });
  }, 100);
});
